unit UGridHelper;

interface

uses
  WebLib.Grids, UStampModel, UUserModel, WebLib.ExtCtrls;

procedure ClearGrid(Grid: TStringGrid);
procedure SetStatusGrid(Grid: TStringGrid; Stamp: TStampModel;
  FakStamp: TStampModel; SmallLayout: Boolean; Panel: TPanel;
  User: TUserModel);

implementation

procedure ClearGrid(Grid: TStringGrid);
var
  r, c: Integer;
begin
  for r := 0 to Grid.RowCount - 1 do
    for c := 0 to Grid.ColCount - 1 do
      Grid.Cells[c, r] := '';
end;

procedure SetStatusGrid(Grid: TStringGrid; Stamp: TStampModel;
  FakStamp: TStampModel; SmallLayout: Boolean; Panel: TPanel;
  User: TUserModel);
begin
  ClearGrid(Grid);
  Grid.ColCount := 0;
  Grid.RowCount := 0;
  if SmallLayout then
  begin
    Grid.ColCount := 2;
    Grid.ColWidths[0] := 5;
    Grid.ColWidths[1] := Panel.ClientWidth - Grid.ColWidths[0];
    if Stamp <> nil then
    begin
      Grid.RowCount := Grid.RowCount + 2;
      Grid.Cells[1, 0] := User.ToString;
      Grid.Cells[1, 1] := Stamp.status;
    end;
    if (FakStamp <> nil) and (FakStamp.Fak <> nil) and
      (FakStamp.Fak.Bezeichnung <> '') then
    begin
      Grid.RowCount := Grid.RowCount + 1;
      Grid.Cells[1, Grid.RowCount - 1] := FakStamp.Fak.ToString;
    end;
    if (FakStamp <> nil) and (FakStamp.Taet <> nil) and
      (FakStamp.Taet.Bezeichnung <> '') then
    begin
      Grid.RowCount := Grid.RowCount + 1;
      Grid.Cells[1, Grid.RowCount - 1] := FakStamp.Taet.ToString;
    end;
  end
  else
  begin
    Grid.ColCount := 3;
    Grid.ColWidths[0] := 5;
    Grid.ColWidths[1] := (Panel.ClientWidth - Grid.ColWidths[0]) div 2;
    Grid.ColWidths[2] := Panel.ClientWidth - Grid.ColWidths[0] -
      Grid.ColWidths[2];
    if Stamp <> nil then
    begin
      Grid.RowCount := Grid.RowCount + 1;
      Grid.Cells[1, 0] := User.ToString;
      Grid.Cells[2, 0] := Stamp.status;
    end;
    if (FakStamp <> nil) and
      (((FakStamp.Fak <> nil) and (FakStamp.Fak.Bezeichnung <> '')) or
      ((FakStamp.Taet <> nil) and (FakStamp.Taet.Bezeichnung <> ''))) then
    begin
      Grid.RowCount := Grid.RowCount + 1;
      if (FakStamp.Fak <> nil) and (FakStamp.Fak.Bezeichnung <> '') then
        Grid.Cells[1, Grid.RowCount - 1] := 'Auftrag: ' + FakStamp.Fak.ToString;
      if (FakStamp.Taet <> nil) and (FakStamp.Taet.Bezeichnung <> '') then
        Grid.Cells[2, Grid.RowCount - 1] := 'Tätigkeit: ' +
          FakStamp.Taet.ToString;
    end;
  end;
  Panel.Height := (Grid.RowCount * 24) + 4;
end;

end.
